import React, { Component } from 'react';


class About extends Component {
    render() {
        return (
            <div className="about">
                <section id="banner" className="banner no-padding">
                    <div className="container-fluid">
                        <div className="row no-gutter">
                            <ul className="slides">
                                <li>
                                    <div className="col-md-12 title_fontstyle">
                                        <blockquote>
                                            <p>About me</p>
                                        </blockquote>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>


                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12 col-sm-7">
                                <div className="bio">
                                    <div className="bio-content">
                                        <h4>On Yong Wai Sze</h4>
                                        <h5> Graphic Designer, Front-end Developer</h5>
                                        <p >Gender : female </p>
                                        <p >Birthday : 17 May 1991</p>
                                        <p >Marital Status : Single</p>
                                        <p >Nationality : Malaysia</p>
                                    </div><br/><br/>

                                    <div className="bio-content">

                                        <p>Hello, my name is On Yong Wai Sze. I am a Front End Developer and Graphic Designer with nearly 4 years of experience
                                            Highly creative coupled with strong learning ability, I have good knowledge of Adobe Illustrator, Photoshop,
                                            Dreamweaver,  Premier, HTML/HTML5, CSS/CSS3, Bootstrap, React JS,
                                            Node JS and Invasion. Able to complete projects efficiently and satisfy customers with attractive,
                                            user-friendly websites. Thrives in environments that constantly embrace new technologies and a team player</p>


                                    </div>







                                </div>
                            </div>
                        </div>
                    </div>
                </section>



                <h4 className="ui horizontal divider header line-style">
                    <i className="bar chart icon"></i>
                    EDUCATION
                </h4>


                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12 col-sm-7">
                                <div className="bio">
                                    <div className="bio-content">


                                        <p >NEW ERA UNIVERSITY COLLEGE , Kajang , Malaysia
                                            Diploma in Media Techiniques Level 3, City & Guids UK. </p>

                                    </div><br/>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>








                <h4 className="ui horizontal divider header line-style">
                    <i className="bar chart icon"></i>
                    EXPERIENCE (2015)
                </h4>


                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12 col-sm-7">
                                <div className="bio">
                                    <div className="bio-content">

                                        <h3 className='ul_margin_style'>Interbase Resources Sdn Bhd (Lelong.my)   <p>Web Designer - (intern) </p></h3><br/>

                                        <p role="listitem" className="item ">1: Responsible for the daily Newsletter designe. </p>
                                        <p role="listitem" className="item">2: Design Web Layout.</p>
                                        <p role="listitem" className="item">3: Design Web Banner.</p>
                                        <p role="listitem" className="item">4: Design Web Page and Convert to HTML..</p>

                                    </div><br/>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>








                <h4 className="ui horizontal divider header line-style">
                    <i className="bar chart icon"></i>
                    EXPERIENCE (2015~2016)
                </h4>


                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12 col-sm-7">
                                <div className="bio">
                                    <div className="bio-content">

                                        <h3 className='ul_margin_style'>The Store Corporation Berhad , Petaling Jaya     <p>(Junior Graphic Designer)</p></h3><br/>

                                        <p role="listitem" className="item ">1: Responsible for the daily press add newspaper design. </p>
                                        <p role="listitem" className="item">2: Design web banner</p>
                                        <p role="listitem" className="item">3: Video Edit</p>

                                    </div><br/>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>














                <h4 className="ui horizontal divider header line-style">
                    <i className="bar chart icon"></i>
                    EXPERIENCE (2016~2018)
                </h4>


                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12 col-sm-7">
                                <div className="bio">
                                    <div className="bio-content">

                                        <h3 className='ul_margin_style'>STAR GAMING TECHNOLOGY SDN BHD     <p>(FrontEnd Developer)</p></h3><br/>

                                        <p role="listitem" className="item ">1: Design layout.  </p>
                                        <p role="listitem" className="item">2:  convert website  to html5 </p>
                                        <p role="listitem" className="item">3:  convert website to Raact js  </p>
                                        <p role="listitem" className="item">4:  responsive website to mobile size  </p>

                                    </div><br/>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>










                <h4 className="ui horizontal divider header line-style">
                    <i className="bar chart icon"></i>
                    Computer Skills
                </h4>


                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12 col-sm-7">
                                <div className="bio">
                                    <div className="bio-content">



                                        <p role="listitem" className="item ">1: Adobe Illustrator </p>
                                        <p role="listitem" className="item">2: Adobe Photashop.</p>
                                        <p role="listitem" className="item">3: Adobe Dreamweaver</p>
                                        <p role="listitem" className="item">4: Adobe Premiere</p>
                                        <p role="listitem" className="item ">5: Adobe InDesign</p>
                                        <p role="listitem" className="item">6: Adobe Photashop</p>
                                        <p role="listitem" className="item">7: Proshow (Video Eddit)</p>
                                        <p role="listitem" className="item">8: HTML/HTML5 </p>
                                        <p role="listitem" className="item">9: CSS/CSS3 </p>
                                        <p role="listitem" className="item">10: js/jquery </p>
                                        <p role="listitem" className="item">11: Bootstrap </p>
                                        <p role="listitem" className="item">12: Node js </p>
                                        <p role="listitem" className="item">13: React Js </p>
                                        <p role="listitem" className="item">14: Invision </p>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>




                <h4 className="ui horizontal divider header line-style">
                    <i className="bar chart icon"></i>
                    Language
                </h4>


                <section id="teams" className="section teams">
                    <div className="container">
                        <div className="row">

                            <div className="col-md-12 col-sm-7">
                                <div className="bio">
                                    <div className="bio-content">

                                        <p role="listitem" className="item">1: English  -   Normal</p>
                                        <p role="listitem" className="item">2: Malay     -  Normal</p>
                                        <p role="listitem" className="item">3: Chinese   -  Fluent </p>
                                        <p role="listitem" className="item">4: Contonese - Fluent </p>


                                    </div><br/>


                                </div>
                            </div>
                        </div>
                    </div>
                </section>




            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/page/about/About.js